import { render } from "./WidgetAngularLibrary.vue?vue&type=template&id=81e9a86e&scoped=true&ts=true"
import script from "./WidgetAngularLibrary.vue?vue&type=script&lang=ts"
export * from "./WidgetAngularLibrary.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e9a86e"]])

export default __exports__